<div class="d-flex">
  <a [routerLink]="routerLink" class="back-to-login">
    @if (direction === 'back') {
      <img src="../../assets/icon/back.svg" alt="Back">
    }
    <span class="back-to-login-text">{{ linkText | translate }}</span>
    @if (direction === 'forward') {
      <img src="../../assets/icon/forward.svg" alt="Forward">
    }
  </a>
</div>